module.exports = __webpack_public_path__ + "img/icon-p2p.svg";